<section class="flex flex-col w-full">
  <ng-container *ngIf="fileResources && fileResources.length > 0">
    <p><strong>Existing files:</strong></p>
    <ng-container *ngFor="let fileResource of fileResources">
      <article class="flex items-center justify-between my-1">
        <div class="grow flex flex-row cursor-pointer" (click)="downloadDocument(fileResource)">
          <ts-icon [icon]="'insert_drive_file'"></ts-icon>
          <p class="ml-2">{{ fileResource.name }}</p>
        </div>
        <div class="flex-none flex items-center flex-row">
          <p class="mr-4">{{ fileResource.created_at | date: 'MMM dd, y' }}</p>
          <ts-button
            [type]="'icon'"
            [icon]="'delete'"
            [color]="'basic'"
            (click)="deleteAttachment(fileResource)"
          ></ts-button>
        </div>
      </article>
      <mat-divider></mat-divider>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="documentsToUpload && documentsToUpload.length > 0">
    <p><strong>Files to be added:</strong></p>
    <ng-container *ngFor="let file of documentsToUpload">
      <article class="flex items-center justify-between my-1">
        <div class="grow flex flex-row">
          <ts-icon [icon]="'insert_drive_file'"></ts-icon>
          <p class="ml-2">{{ file.name }}</p>
        </div>
        <div class="flex-none flex items-center flex-row">
          <p class="mr-4">{{ file.lastModifiedDate | date: 'MMM dd, y' }}</p>
          <ts-button [type]="'icon'" [icon]="'delete'" [color]="'basic'" (click)="removeAttachment(file)"></ts-button>
        </div>
      </article>
      <mat-divider></mat-divider>
    </ng-container>
  </ng-container>

  <article class="mt-2">
    <input hidden type="file" (change)="onFileChanged($event)" #fileInput />
    <ts-button [color]="'primary'" [icon]="'attach_file'" (click)="fileInput.click()"> Upload file </ts-button>
  </article>
</section>
